import axios from "axios";
var url = '';
if(window.location.origin == 'https://aiq.zens10.com'){
  url = 'https://apps.zens10.com/'
} else if(window.location.origin == 'http://localhost:8080'){
  url = 'https://lite.zens10.com/'
} else {
  url = 'https://app.zens10.com/'
};
const service  = axios.create({
  baseURL:url,
  timeout:60000
});

export default service 


// WEBPACK FOOTER //
// ./src/assets/js/request.js